import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import {
  CoverageSchema,
  EnrichmentSource,
} from '@/services/types/coverage-types';

interface CoverageSourceBadgeProps {
  coverage: CoverageSchema;
  className?: string;
}

/** Sources that indicate AI extraction (including legacy enrichment values). */
const AI_EXTRACTED_SOURCES: EnrichmentSource[] = [
  EnrichmentSource.EXTRACTION,
  EnrichmentSource.PERPLEXITY,
  EnrichmentSource.CACHED,
];

/** Shared badge styles - matches other card header badges. */
const badgeStyles = cn(
  'text-[10px] font-medium border-0 px-1.5 py-0 h-4',
  'bg-zinc-100 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-300',
);

/**
 * Displays the source/attribution of a coverage entry.
 */
export const CoverageSourceBadge = ({
  coverage,
  className,
}: CoverageSourceBadgeProps) => {
  const { enrichment_source, created_by_user_name } = coverage;

  const getSourceLabel = (): string => {
    if (enrichment_source && AI_EXTRACTED_SOURCES.includes(enrichment_source)) {
      return 'System';
    }
    if (enrichment_source === EnrichmentSource.INTAKE) {
      return 'Intake';
    }
    if (enrichment_source === EnrichmentSource.MANUAL) {
      return created_by_user_name || 'Manual';
    }
    return 'Unknown';
  };

  return (
    <Badge variant="secondary" className={cn(badgeStyles, className)}>
      Source: {getSourceLabel()}
    </Badge>
  );
};
